import { render, staticRenderFns } from "./AddToRemoveFromWatchlist.vue?vue&type=template&id=5eb55fef&scoped=true"
import script from "./AddToRemoveFromWatchlist.vue?vue&type=script&lang=js"
export * from "./AddToRemoveFromWatchlist.vue?vue&type=script&lang=js"
import style0 from "./AddToRemoveFromWatchlist.vue?vue&type=style&index=0&id=5eb55fef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb55fef",
  null
  
)

export default component.exports